import React from "react";
import { useRouter } from "next/router";
import LeftArrowAccordian from "../../../icons/LeftArrowAccordian";
import BidderForm from "./BidderForm";
import CrossIcon from "../../../icons/CrossIcon";
import { JBFormWrapper } from "./JointBidder/JBFormWrapper";

interface props {
  mode?: string;
}
export const AddBidder = ({ mode }: props) => {
  const router = useRouter();
  return (
    <div className="px-4 py-5 lg:py-6 lg:px-8">
      <div className="flex  items-center">
        <div className="flex items-center w-full lg:w-fit">
          <button
            className="hidden lg:flex"
            onClick={() => {
              router.back();
            }}
          >
            <LeftArrowAccordian className="h-6 w-6" />
          </button>
          <p className="font-openSans font-normal text-mobile-h3 lg:text-web-subheading leading-8 lg:leading-6 lg:ml-5 text-bankerColor">
            {mode === "view"
              ? "Bidder Details"
              : mode === "joint-creation"
              ? "Add Joint Bidder Details"
              : mode === "edit"
              ? "Update Bidder Details"
              : "Add Bidder"}
          </p>
          <div
            onClick={() => {
              router.back();
            }}
            className="ml-auto lg:hidden mb-5"
          >
            <CrossIcon />
          </div>
        </div>
      </div>
      {mode === "joint-creation" ? (
        <JBFormWrapper />
      ) : (
        <BidderForm mode={mode} />
      )}
    </div>
  );
};

export default AddBidder;
